import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

import Navbar from '@/pages/Navbar/Navbar';
import Rodape from '@/pages/Rodape/Rodape';

const imagens = [
  '/galeria/foto1.jpg',
  '/galeria/foto2.jpg',
  '/galeria/foto3.jpg',
  '/galeria/foto4.jpg',
  '/galeria/foto5.jpg',
  '/galeria/foto6.jpg',
  '/galeria/foto7.jpg',
  '/galeria/foto8.jpg',
  '/galeria/foto9.jpg',
  '/galeria/foto10.jpg',
  '/galeria/foto11.jpg',
  '/galeria/foto12.jpg',
];

export default function Fotos() {
  const [aberto, setAberto] = useState(false);
  const [fotoAtual, setFotoAtual] = useState(0);

  const slides = imagens.map((src) => ({ src }));

  return (
    <>
      <Navbar />
      <section className="bg-gradient-to-b from-gray-50 to-white py-16 px-4 min-h-screen">
        <div className="max-w-7xl mx-auto text-center">
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-800 mb-8"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Explore Nossa Galeria de Serviços
          </h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            Confira abaixo algumas imagens que destacam a qualidade e dedicação dos nossos serviços.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {imagens.map((src, index) => (
              <div
                key={index}
                className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300"
                onClick={() => {
                  setFotoAtual(index);
                  setAberto(true);
                }}
              >
                <img
                  src={src}
                  alt={`Foto ${index + 1}`}
                  className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-sm font-semibold">Ver em tamanho maior</p>
                </div>
              </div>
            ))}
          </div>

          {/* Golden Line */}
          <div className="mt-12 h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent"></div>
        </div>

        {aberto && (
          <Lightbox
            open={aberto}
            close={() => setAberto(false)}
            slides={slides}
            index={fotoAtual}
            on={{
              view: ({ index }) => setFotoAtual(index),
            }}
          />
        )}
      </section>
      <Rodape />
    </>
  );
}
